import React from 'react';
import LegalDocument from '../components/LegalDocument';
import privacyEn from '../legal/privacy.en.json';
import privacyZh from '../legal/privacy.zh.json';

const content = { en: privacyEn, zh: privacyZh };

function Privacy({ language }) {
  const doc = content[language] || content.en;

  return (
    <div className="legal-page">
      <LegalDocument
        title={doc.title}
        effective={doc.effective}
        lastUpdated={doc.lastUpdated}
        intro={doc.intro}
        tocLabel={doc.toc}
        backLabel={doc.back}
        sections={doc.sections}
      />
    </div>
  );
}

export default Privacy;
